module.exports = __webpack_public_path__ + "img/116.a037308a.jpg";